// NewLeadModalWrapper.js
import React from 'react';
import NewLeadModal from './NewLeadModal'; // Assuming this path is correct

const NewLeadModalWrapper = ({ isOpen, onClose, onLeadAdded, lead }) => {
  return (
    <NewLeadModal
      isOpen={isOpen}
      onClose={onClose}
      onLeadAdded={onLeadAdded}
      lead={lead}
    />
  );
};

export default NewLeadModalWrapper;